export default __webpack_public_path__ + "static/media/2_0052.40d0e2f0.webp";